import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

/**
 * Intercepts http calls and if they start with `/api` it replaces localhost URL with the Doorwifi API base URL.
 *
 * @param req
 * @param next
 * @constructor
 */
export const ApiRequestInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    // Get the request url.
    let requestUrl = req.url;

    // Only match urls starting with /api so that angular fetch resources don't get affected.
    if (requestUrl.indexOf('api/') !== -1) {
        requestUrl = `${environment.apiBaseUrl}/${requestUrl}`
    }

    // HttpRequest is an immutable object, so we need to create a copy with the url desired changes.
    const apiReq = req.clone({
        url: requestUrl }
    );

    return next(apiReq);
}
